import React from "react";
import classes from "@/app/components/algolia/ToolbarBottom/algoliaTollbarBottomStyles.module.scss";
import Pagination from "@/app/components/algolia/Pagination";
import HitsPerPageSelect from "@/app/components/algolia/HitsPerPageSelect";
import {TAlgoliaConfigProvider} from "@/app/components/algolia/AlgoliaProvider";

/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
const ToolbarBottom = (props: {
    className?: string
}) => {
    return <div className={classes.toolbar}>
        <Pagination />
        <HitsPerPageSelect className={classes['show-wrapper']} />
    </div>
}

export default ToolbarBottom;